import { useShowFirstUploadPromptValue } from '~/components/v2/store/features/onboarding/useOnboardingPreferencesStore';
import { useAnimatedOnboardingUploadVisibility } from '~/components/WorkspaceOnboardingForm/hooks/useAnimatedOnboardingUploadVisibility';
import { useCurrentWorkspace } from '~/providers/CurrentWorkspaceProvider';

export const useShowOnboardingUploadPrompt = (): { showOnboardingUploadPrompt: boolean } => {
  const { currentWorkspace } = useCurrentWorkspace();
  const workspaceId = currentWorkspace?.id;
  const showWorkspaceOnboardingUploadPrompt = useShowFirstUploadPromptValue(workspaceId);
  const { showPendingAnimatedUploadStep } = useAnimatedOnboardingUploadVisibility(workspaceId);

  return {
    showOnboardingUploadPrompt: showWorkspaceOnboardingUploadPrompt || showPendingAnimatedUploadStep,
  };
};
